/**
 * Words in a chip - a locked filter's, whose chat it is - in the room an ``sm``
 * button gives its own beside them (shadcn's ``ButtonGroupText`` has the
 * default button's, wider).
 */
export const CHIP_WORDS_CLASS = "gap-1.5 px-3 has-[>svg]:px-2.5";

/**
 * Convert a name to a test ID format (lowercase, hyphenated; "Document → Type"
 * is document-type). One for every part of the chip, so a related filter's
 * name, operator, value and close buttons all carry the same id.
 */
export const toTestId = (name: string): string =>
  name?.toLowerCase().replace(/\s*→\s*|\s+/g, "-") ?? "";
